import * as React from 'react';

import { DocumentTitle } from 'Components/DocumentTitle/DocumentTitle';
import { useFetchColumnMappings } from 'Hooks/UseFetchSOV';
import { Table, Tooltip } from 'antd';
import Pagination from "@mui/material/Pagination";
import IconButton from '@mui/material/IconButton';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { Input } from 'antd';
import { useDebounce } from 'Hooks/UseDebounce';
import AlertDialogSlide from 'Shared/SharedModal';
import { deleteColumnMappings } from 'Services/UserService';
import { toast } from 'react-toastify';
import { setSpinner } from 'Redux/Slices/Metadata';
import { useDispatch } from 'react-redux';

const ColumnMapping = (props: any) => {

    const dispatch = useDispatch();

    const [page, setPage] = React.useState<number>(1);
    const [search, setSearch] = React.useState<string>('');
    const [modal, setModal] = React.useState<{ id: number | null; flag: boolean; }>({ id: null, flag: false });
    
    const debounceSearch = useDebounce(search, 1000);
    const { columnMappings, totalCount, refreshRender } = useFetchColumnMappings(page, debounceSearch?.toString());

    const columns = [
        {
            dataIndex: 'id',
            title: 'ID',
        },
        {
            dataIndex: 'count',
            title: 'Count',
            sorter: false
        },
        {
            dataIndex: 'value',
            title: 'Value'
        },
        {
            dataIndex: 'mapped_column_key',
            title: 'Mapped Column Key'
        },
        {
        title: 'Action',
        render: (p: any, record: any) => (
            <div className="dropdown dropdown-action text-end" onClick={() => setModal({ id: record.id, flag: true })}>
                <DeleteOutline color='error' style={{ cursor: 'pointer' }} />
            </div>
        )}
    ];

    async function deleteMappings(ids: number[]): Promise<void> {
        try {
            dispatch(setSpinner(true));
            await deleteColumnMappings(ids);
            toast.success('Column mapping deleted successfully.');
            refreshRender(false);
            dispatch(setSpinner(false));
            setModal({ id: null, flag: false });
        }
        catch (err) {
            dispatch(setSpinner(false));
            setModal({ id: null, flag: false });
        }
    }

    return (
        <DocumentTitle condition={true} title="Column Mappings">
            <React.Fragment>

                {modal.flag && <AlertDialogSlide data="Are you sure you want to delete this mapping?" title="Confirm Delete" setmodal={(value: boolean) => setModal({ id: null, flag: value })} actionDelete={() => deleteMappings([modal.id as number])}></AlertDialogSlide>}

                <div className='' style={{ display: 'flex', alignItems: 'center' }}>
                    <Input.Search value={search} placeholder={`Search Mappings`} enterButton enterKeyHint="search" size="large" loading={false} allowClear 
                        onSearch={() => {}}
                        onChange={(e) => setSearch(e.target.value)} 
                        style={{ flexShrink: 0, width: '250px', marginRight: '10px' }}
                    />
                    <div style={{ textAlign: 'center', minWidth: '170px', fontSize: '16px' }}><span style={{ fontWeight: 'bold' }}>Total Rows: </span>{totalCount ?? 0}</div>
                </div>

                <div className="table-responsive shadow bg-white p-2 mt-2">
                    <Table className="table-striped"
                        pagination={false}
                        columns={columns}
                        dataSource={columnMappings}
                        rowKey={record => record.id}
                        onChange={() => {}}
                    />
                </div>

                <Pagination count={Math.ceil(totalCount / 10)} page={page} onChange={(event: React.ChangeEvent<unknown>, value: number) => {
                    setPage(value);
                }} style={{ marginTop: 10 }} />
            </React.Fragment>
        </DocumentTitle>
    );
}

export default ColumnMapping;